export default "__VITE_ASSET__Dnl7j7nD__"